import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  NgZone,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent implements AfterViewInit, OnDestroy {
  isBannerVisible = false;
  private statusObserver?: MutationObserver;

  constructor(
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone
  ) {}

  @ViewChild('adElement') adElement?: ElementRef<HTMLElement>;

  ngAfterViewInit() {
    const adElement = this.adElement?.nativeElement;
    if (!adElement) {
      this.logMissingElement();
      return;
    }

    this.logBannerStatus('mounted', adElement);

    this.statusObserver = new MutationObserver(() => {
      this.ngZone.run(() => this.syncAdStatus(adElement));
    });
    this.statusObserver.observe(adElement, {
      attributes: true,
      attributeFilter: ['data-ad-status'],
    });

    this.requestAdSenseBanner(adElement);
    this.syncAdStatus(adElement);
  }

  ngOnDestroy() {
    this.statusObserver?.disconnect();
  }

  private requestAdSenseBanner(adElement: HTMLElement) {
    setTimeout(() => {
      try {
        ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push(
          {}
        );
        this.logBannerStatus('requested', adElement);
      } catch (error) {
        this.logBannerStatus('request-failed', adElement, error);
        this.setBannerVisible(false);
      }
    });
  }

  private syncAdStatus(adElement: HTMLElement) {
    const status = adElement.getAttribute('data-ad-status');
    this.setBannerVisible(status === 'filled');
    this.logBannerStatus(status || 'pending', adElement);
  }

  private setBannerVisible(isVisible: boolean) {
    if (this.isBannerVisible === isVisible) {
      return;
    }

    this.isBannerVisible = isVisible;
    this.cdr.markForCheck();
  }

  private logBannerStatus(
    status: string,
    adElement: HTMLElement,
    error?: unknown
  ) {
    if (environment.production) {
      return;
    }

    const wrapper = adElement.closest('.banner-wrap') as HTMLElement | null;
    const wrapperHeight = wrapper?.getBoundingClientRect().height ?? 0;
    const adHeight = adElement.getBoundingClientRect().height;

    console.debug('[adsense-banner]', {
      status,
      route: window.location.pathname,
      slot: adElement.getAttribute('data-ad-slot'),
      dataAdStatus: adElement.getAttribute('data-ad-status'),
      visible: this.isBannerVisible,
      adsbygoogleReady: Array.isArray((window as any).adsbygoogle),
      wrapperHeight,
      adHeight,
      error,
    });
  }

  private logMissingElement() {
    if (environment.production) {
      return;
    }

    console.warn('[adsense-banner]', {
      status: 'missing-ad-element',
      route: window.location.pathname,
    });
  }
}
